/*
 * Community map.
 *
 * Leaflet and its stylesheet are only fetched once a map is actually on the
 * page, so every other page in the store stays free of them.
 */
(function () {
  var LEAFLET_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js';
  var LEAFLET_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css';

  function loadCss(href) {
    return new Promise(function (resolve) {
      if (document.querySelector('link[href="' + href + '"]')) return resolve();
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = resolve;
      l.onerror = resolve; // a missing stylesheet is ugly, not fatal
      document.head.appendChild(l);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (window.L) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('leaflet failed to load')); };
      document.head.appendChild(s);
    });
  }

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(el) {
    if (el.dataset.pnfMapReady) return;
    el.dataset.pnfMapReady = '1';

    var pinsUrl = el.getAttribute('data-pins');

    Promise.all([
      loadCss(LEAFLET_CSS),
      loadScript(LEAFLET_JS),
      fetch(pinsUrl, { credentials: 'omit' }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var data = results[2];
      var pins = (data && data.pins) || [];

      var map = L.map(el, {
        center: [num(el.getAttribute('data-lat'), 48), num(el.getAttribute('data-lng'), 12)],
        zoom: num(el.getAttribute('data-zoom'), 3),
        scrollWheelZoom: false, // a map that swallows page scroll is a nuisance
        worldCopyJump: true
      });

      L.tileLayer(el.getAttribute('data-tile-url'), {
        attribution: el.getAttribute('data-attribution'),
        maxZoom: 12
      }).addTo(map);

      var marker = L.divIcon({
        className: 'pnf-pin',
        html: '<span class="pnf-pin__dot"></span>',
        iconSize: [14, 14],
        iconAnchor: [7, 7]
      });

      var bounds = [];
      pins.forEach(function (p) {
        if (typeof p.lat !== 'number' || typeof p.lng !== 'number') return;
        bounds.push([p.lat, p.lng]);
        L.marker([p.lat, p.lng], { icon: marker, title: p.place || p.name || '' })
          .addTo(map)
          .bindPopup(
            '<strong>' + escapeHtml(p.name) + '</strong>' +
            (p.place ? '<br>' + escapeHtml(p.place) : '') +
            (p.note ? '<br><em>' + escapeHtml(p.note) + '</em>' : '')
          );
      });

      if (bounds.length > 1) map.fitBounds(bounds, { padding: [40, 40], maxZoom: 6 });

      var count = document.querySelector('[data-pnf-map-count]');
      if (count && pins.length) {
        count.textContent = pins.length === 1
          ? count.getAttribute('data-one') || '1 pin so far'
          : pins.length + (count.getAttribute('data-many') || ' nomads on the map');
        count.hidden = false;
      }
    }).catch(function () {
      el.innerHTML = '<p class="pnf-community__fallback">' +
        'The map could not be loaded right now.</p>';
    });
  }

  function boot() {
    document.querySelectorAll('[data-pnf-map]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify's theme editor tears sections down and rebuilds them.
  document.addEventListener('shopify:section:load', boot);
})();
